module.exports = __webpack_public_path__ + "img/C05TechDecurionChampion_ua.fa3cb5bc.webp";